/**
 * useFeature — read a tenant feature flag (Phase 3, F6).
 *
 * Flags come from GET /users/me/permissions and are stored on the auth user.
 * While permissions are loading (or failed to load) every flag reads false,
 * so flagged UI never flashes in before the tenant's flags are known.
 *
 * @module hooks/useFeature
 */

import { useAuth } from '../context/authcontext';
import type { FeatureKey } from '../constants/features';

export type { FeatureKey } from '../constants/features';

export const useFeature = (key: FeatureKey): boolean => {
  const { user } = useAuth();
  return user?.features?.[key] ?? false;
};

export default useFeature;
